// extracted by mini-css-extract-plugin
module.exports = {"label":"form-select_label__qxn_K","select":"form-select_select__AD_Ei","error":"form-select_error__zjtNe","error-message":"form-select_error-message__UjQEH"};